import { useQuery } from "@tanstack/react-query";
import { CommercialOperation, ConfrontationService } from "./_request";

export const useQueryOperationsTypeForSelect = (params?: any) => {
  return useQuery({
    queryKey: ["queryOperationsType"],
    queryFn: async () => CommercialOperation.getAllOperationsForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: item?.["@id"],
        }));
      } else {
        return [];
      }
    },
  });
};

export const useQueryOperationsShiftingForSelect = (params?: any) => {
  return useQuery({
    queryKey: ["queryOperationsShifting"],
    queryFn: async () =>
      CommercialOperation.getAllOperationsShiftingForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: item?.["@id"],
        }));
      } else {
        return [];
      }
    },
  });
};

export const useQueryOperationsModelListForSelect = (params?: any) => {
  return useQuery({
    queryKey: ["queryOperationsModelList"],
    queryFn: async () => CommercialOperation.getAllModelListForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: item?.["@id"],
        }));
      } else {
        return [];
      }
    },
  });
};

export const useQueryConfrontationTypeSelect = (params?: any) => {
  return useQuery({
    queryKey: ["queryConfrontationTypeSelect"],
    queryFn: async () =>
      ConfrontationService.getConfrontationTypeSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

export const useQueryConfrontationStateSelect = (params?: any) => {
  return useQuery({
    queryKey: ["queryConfrontationStateSelect"],
    queryFn: async () =>
      ConfrontationService.getConfrontationStatusSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};
